<div class="pure-g m-t-16" style="align-items: center; display: flex; justify-content: flex-end">
  <div class="pure-u-md-6-24 pure-u-lg-5-24 pure-u-xl-4-24 right">
    @if (canAddNew) {
      <mc-button
        label="Add New"
        (click)="onAddNewClicked()"
        (keydown.enter)="onAddNewClicked()"
        variant="filled"
        appearance="primary"
        fit="small">
      </mc-button>
    }
  </div>
</div>

<div class="m-t-8 quick-filter-box">
  <div class="applied-filter-holder">
    @for (taggedFilter of taggedFilters; track taggedFilter.key) {
      <!-- Filter Label -->
      <div class="m-r-4" style="white-space: nowrap">
        {{ taggedFilter.key }}
      </div>

      <!-- REPAIR CODE -->
      @if (taggedFilter.key === 'Repair Code - Description' && isArrayType(taggedFilter.value)) {
        <app-tag-with-overflow [data]="getTaggedRepairCodes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectRepairCode()">
        </app-tag-with-overflow>
      }

      <!-- MODE -->
      @if (taggedFilter.key === 'Mode' && isArrayType(taggedFilter.value)) {
        <app-tag-with-overflow [data]="getTaggedModes()" [overflowCount]="2" [withaction]="true" [dismiss]="unselectMode()">
        </app-tag-with-overflow>
      }

    }

    <!-- CLEAR ALL -->
    @if (taggedFilters.length > 0) {
      <a>
        <mc-button
          class="clear-btn"
          variant="plain"
          appearance="primary"
          fit="small"
          padding="default"
          (click)="clearAllSelectedFilters()"
          (keydown.enter)="clearAllSelectedFilters()">
          Clear All
        </mc-button>
      </a>
    }
  </div>

  <!-- RIGHT SIDE FILTER + DOWNLOAD BUTTONS -->
  <div class="utility-buttons">
    <div style="display: flex; align-items: right; gap: 1px">
      <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
        <mc-button
          class="utility-button-no-round"
          slot="trigger"
          icon="sliders-horizontal"
          variant="filled"
          appearance="neutral"
          hiddenlabel
          padding="default"
          fit="medium"
          (click)="showAdvanceFiltersModal()"
          (keydown.enter)="showAdvanceFiltersModal()">
        </mc-button>
        <span>Filters</span>
      </mc-tooltip>
      @if (authPolicies.canViewRepairCodeExclusion) {
        <mc-button
          class="utility-button download"
          variant="filled"
          appearance="neutral"
          fit="medium"
          [loading]="isDownload"
          icon="tray-arrow-down"
          hiddenlabel
          padding="default"
          (click)="onDownload()"
          (keydown.enter)="onDownload()">
        </mc-button>
      }
    </div>
  </div>
</div>

<mc-modal
  backdropcloseactiondisabled
  [open]="showAdvanceFilters"
  (closed)="closeAdvanceFiltersModal()"
  heading="Filters"
  fit="small"
  dimension="large">
  @if (showAdvanceFilters) {
    <app-repair-code-exclusion-advanced-filter [filterForm]="filterFormGroup.controls.filterForm">
    </app-repair-code-exclusion-advanced-filter>
  }
</mc-modal>
